import { ApolloClient, createNetworkInterface } from "react-apollo";
import API_SERVER from "../network";

const { NODE_ENV } = process.env;
const graphqlURL = NODE_ENV === "development" ? API_SERVER : "";

const networkInterface = createNetworkInterface({
  uri: `${graphqlURL}/graphql/`
});

networkInterface.use([
  {
    applyMiddleware(req, next) {
      if (!req.options.headers) {
        req.options.headers = {};
      }

      const token = localStorage.getItem("PPJWT");
      req.options.headers.authorization = `Bearer ${token}`;
      next();
    }
  }
]);

const client = new ApolloClient({ networkInterface });

export default client;



// WEBPACK FOOTER //
// /src/apollo/index.js